import { State as AuthState } from "./authSlice";
import { apiSlice } from "../api/apiSlice";

interface OpenIdAuthData {
  email: string;
  name: string;
  picture: string | null;
  api_token: string;
  api_token_valid_until: string;
}

export interface OpenIdAuthArgs {
  credential: string;
  authority: string;
}

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    openIdAuthenticate: builder.query<AuthState, OpenIdAuthArgs>({
      query: ({ credential, authority }) => ({
        url: "/openid_authenticate",
        method: "POST",
        headers: [["X-Audere-Token-Authority", authority]],
        body: JSON.stringify({ credential }),
      }),
      keepUnusedDataFor: 0,
      transformResponse: (result: OpenIdAuthData, meta, arg) => {
        return {
          email: result.email,
          name: result.name,
          picture: result.picture,
          credentials: arg.credential,
          authority: arg.authority,
          token: result.api_token,
          expires: result.api_token_valid_until,
        };
      },
    }),
  }),
});

export const { useLazyOpenIdAuthenticateQuery } = authApiSlice;
